var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.082 39.582v-16.492c0-11.602 10.258-21.008 22.918-21.008 12.656 0 22.918 9.4141 22.918 21.008v16.492h4.6484c4.3359 0 7.8516 3.7383 7.8516 8.3281v41.68c0 4.5977-3.5156 8.3281-7.8516 8.3281h-55.133c-4.3359 0-7.8516-3.7383-7.8516-8.3281v-41.68c0-4.5977 3.5156-8.3281 7.8516-8.3281zm-4.1641 8.3359v41.664h54.164v-41.664zm41.664-8.3359v-16.492c0-6.8242-6.3789-12.672-14.582-12.672-8.2109 0-14.582 5.8398-14.582 12.672v16.492zm-18.75 24.102c0-2.3008 1.8516-4.1641 4.168-4.1641 2.3008 0 4.168 1.8477 4.168 4.1641v12.504c0 2.3008-1.8516 4.1641-4.168 4.1641-2.3008 0-4.168-1.8477-4.168-4.1641z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAlt);
export default __webpack_public_path__ + "static/media/lock-alt.ebace0d90746a260f1abb19cf475a53e.svg";
export { ForwardRef as ReactComponent };